import { FC } from "react";
import { Outlet } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { useAccount } from "wagmi";

import { Alert } from "@dzambalaorg/ui-kit";

export const WalletWrapper: FC = () => {
  const { isConnected } = useAccount();

  if (isConnected) {
    return <Outlet />;
  }

  return (
    <Alert severity="error">
      <FormattedMessage id="snackbar.walletIsNotConnected" />
    </Alert>
  );
};
